// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".annotation-list{padding-right:10px;overflow-y:scroll;position:relative}\n", ""]);
// Exports
module.exports = exports;
